type TemplateResumeMarkIconProps = {
  active?: boolean
  className?: string
  strokeWidth?: number
}

export default function TemplateResumeMarkIcon({
  active = false,
  className = 'w-4 h-4',
  strokeWidth = 2,
}: TemplateResumeMarkIconProps) {
  return (
    <svg
      className={`${className} ${active ? 'text-brand-primary' : 'text-text-secondary'}`}
      fill={active ? 'currentColor' : 'none'}
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d="M17 3H7a2 2 0 00-2 2v16l7-3 7 3V5a2 2 0 00-2-2z"
      />
    </svg>
  )
}
